import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR} from '../theme.js';

export function getBonusesConfig() {
    return {
        custom: {
            [PALETTE_IDS.BONUSES]: {},
        },
        palette: {
            [PALETTE_IDS.BONUSES]: {
                PROMOTION_CODE_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                PROMOTION_CODE_INPUT: {
                    INPUT_BG: COLOR.RESERVED.TRANSPARENT,
                    INPUT_TEXT: COLOR.BRAND.FOREGROUND6,
                    INPUT_BORDER_COLOR: COLOR.BRAND.FOREGROUND6,
                    INPUT_FOCUSED_BORDER_COLOR: COLOR.BRAND.ACCENT1,
                },
                PROMOTION_CODE_SUBMIT_BUTTON: {
                    PRIMARY_BUTTON_BG: COLOR.BRAND.ACCENT1,
                },
            },
        },
    };
}
